export default function(selector) {
  const element = document.querySelector(selector)

  element && element.scrollIntoView({ block: 'start', behavior: 'smooth' })
}
